module.exports = __webpack_public_path__ + "assets/img/f12.508af5aa.png";